import React from 'react';

import i18n from '../../i18n';

// @mui
import { IconButton, TableCell } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';

// Text, Number, Items editorCells are similar
export default class GridItemsCell extends React.Component {
    render() {
        // props: value, id, field
        const value = this.props.value ? this.props.value : '';
        const field = this.props.field;
        const row = this.props.row;
        const variant = field.variant || 'default';
        const extra =
            typeof field.extraRender === 'function'
                ? field.extraRender(value, row)
                : null;
        const enableCopyExtraRender = field.enableCopyExtraRender;

        const baseStyle = this.props.styles;
        const noTranslate = !!this.props.field.noTranslate;

        return (
            <TableCell
                key={this.props.field.id}
                align="left"
                sx={{ ...baseStyle }}
            >
                {variant === 'default' && (
                    <p>
                        {noTranslate
                            ? value
                            : value
                                ? i18n.t(`enums.${value}`)
                                : ''}
                    </p>
                )}
                {extra && (
                    <p>
                        {extra}
                        {enableCopyExtraRender && (
                            <IconButton
                                size="small"
                                onClick={() =>
                                    navigator.clipboard.writeText(extra)
                                }
                                sx={{
                                    "padding": '0 0 0 2px',
                                    "width": '16px',
                                    "height": '16px',
                                    "color": 'text.secondary',
                                    '& svg': { fontSize: '1rem' }
                                }}
                            >
                                <ContentCopy fontSize="inherit" />
                            </IconButton>
                        )}
                    </p>
                )}
                {variant === 'reversed' && (
                    <p>
                        {noTranslate
                            ? value
                            : value
                                ? i18n.t(`enums.${value}`)
                                : ''}
                    </p>
                )}
            </TableCell>
        );
    }
}
